<template>
  <div class="service-contact">
    <service-header :signedIn="signedInUser !== null"/>
    <section class="heading">
      <h2>お問い合わせ</h2>
    </section>
    <section class="body">
      <proa-card flat class="contact-card">
        <div class="form-wrapper">
          <validation-observer v-slot="{ handleSubmit }">
            <form novalidate @submit.prevent="() => { validated = true; handleSubmit(onSubmitCreateIssue) }">
              <proa-input-group :label="$t('models.issue.attributes.name')">
                <template slot="input">
                  <proa-input
                    v-model="issue.name"
                    type="text"
                    :disabled="createNewIssueRequesting"
                    dark
                  />
                </template>
              </proa-input-group>
              <validation-provider
                :name="$t('models.issue.attributes.email')"
                rules="required|email"
                v-slot="{ errors }"
              >
                  <proa-input-group :invalidFeedback="validated ? errors[0] : null" :label="$t('models.issue.attributes.email')" labelWithRequired>
                  <template slot="input">
                    <proa-input
                      v-model="issue.email"
                      type="text"
                      :disabled="createNewIssueRequesting"
                      dark
                    />
                  </template>
                </proa-input-group>
              </validation-provider>
              <proa-input-group :label="$t('models.issue.attributes.phone')">
                <template slot="input">
                  <proa-input
                    v-model="issue.phoneNumber"
                    type="text"
                    :disabled="createNewIssueRequesting"
                    dark
                  />
                </template>
              </proa-input-group>
              <proa-input-group :label="$t('models.issue.attributes.organizationName')">
                <template slot="input">
                  <proa-input
                    v-model="issue.organizationName"
                    type="text"
                    :disabled="createNewIssueRequesting"
                    dark
                  />
                </template>
              </proa-input-group>
              <validation-provider
                :name="$t('models.issue.attributes.content')"
                rules="required"
                v-slot="{ errors }"
              >
                <proa-input-group :invalidFeedback="validated ? errors[0] : null" :label="$t('models.issue.attributes.content')" labelWithRequired>
                  <template slot="input">
                    <proa-input
                      v-model="issue.content"
                      type="textarea"
                      :disabled="createNewIssueRequesting"
                      dark
                    />
                  </template>
                </proa-input-group>
              </validation-provider>
              <div class="mb-4 text-secondary text-center font-weight-w6" style="font-size: 13px;">
                <div>お問い合わせいただく前に下記の「個人情報の取扱について」をお読みいただき、</div>
                <div>記載内容に同意いただける場合は以下の「送信」ボタンを押して、お問合せください。</div>
                <confirm-contact-terms-check-box
                  class="mt-4"
                  :agreedTerms="agreed"
                  @onChange="agreed = !agreed"
                />
              </div>
              <div class="text-center">
                <proa-button
                  :loading="createNewIssueRequesting"
                  :disabled="!agreed"
                  class="default-button-width"
                  type="submit"
                  variant="primary"
                >
                  {{ $t('common.send') }}
                </proa-button>
              </div>
            </form>
          </validation-observer>
        </div>
      </proa-card>
    </section>
    <service-footer
      :signedIn="signedInUser !== null"
      :route="$route.name"
    />
    <proa-modal
      :modal="createdNewIssueModal"
      :title="$t('models.issue.created')"
      @close="$router.push({ name: 'service' })"
    >
      {{ $t('models.issue.createdMessage') }}
    </proa-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ServiceHeader from '@/components/molecules/service/ServiceHeader.vue'
import ServiceFooter from '@/components/molecules/service/ServiceFooter.vue'
import ConfirmContactTermsCheckBox from '@/components/molecules/ConfirmContactTermsCheckBox'

export default {
  name: 'ServiceContact',
  components: {
    ServiceHeader,
    ServiceFooter,
    ConfirmContactTermsCheckBox
  },
  computed: {
    ...mapGetters({
      httpError: 'httpError',
      signedInUser: 'auth/signedInUser'
    })
  },
  data() {
    return {
      createNewIssueRequesting: false,
      createdNewIssueModal: false,
      issue: {
        content: '',
        email: '',
        name: '',
        organizationName: '',
        phoneNumber: ''
      },
      validated: false,
      agreed: false
    }
  },
  methods: {
    async onSubmitCreateIssue() {
      if (!this.agreed) return
      this.createNewIssueRequesting = true
      await this.apiPostIssue(this.issue)
      this.createNewIssueRequesting = false

      if (!this.httpError) this.createdNewIssueModal = true
    },
    ...mapActions({
      apiPostIssue: 'issues/create'
    })
  },
  created() {
    if (this.signedInUser) {
      this.issue.email = this.signedInUser.email
      this.issue.name = this.signedInUser.lastName + this.signedInUser.firstName
      this.issue.phoneNumber = this.signedInUser.meta.phone
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.service-contact {
  width: 100%;
  background-color: white;

  section.body {
    margin-bottom: 200px;
    padding: 0 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .heading {
    padding: 80px 20px 0 20px;

    @include mq(md) {
      padding: 130px 20px 0 20px;
    }

    h2 {
      text-align: center;
      font-size: 26px;
      font-weight: 600;
      line-height: 1.3;
      margin-bottom: 60px;

      @include mq(sm) {
        font-size: 32px;
      }
    }
  }

  .contact-card {
    width: 100%;

    @include mq(sm) {
      width: 600px;
    }
  }

  .form-wrapper {
    padding: 40px 50px;
  }
}
</style>
